import { LazyErrorBoundary, LazyLoadingFallback, LazyLottie } from '@/lib/lazy-components'
import ArrowStopLoader from '@/styles/animations/arrow-stop-loader.json'
import StopLoopLoader from '@/styles/animations/stop-loop-loader.json'
import type { LottieComponentProps } from 'lottie-light-react'
import React from 'react'

export const CancelTurnAnimation = (props: Omit<LottieComponentProps, 'animationData' | 'ref'>) => {
  const [isArrowStopAnimationFinished, setIsArrowStopAnimationFinished] = React.useState(false)
  return (
    <LazyErrorBoundary>
      <React.Suspense fallback={<LazyLoadingFallback className='h-8 w-8' />}>
        {isArrowStopAnimationFinished ? (
          <LazyLottie animationData={StopLoopLoader} {...props} />
        ) : (
          <LazyLottie
            animationData={ArrowStopLoader}
            {...props}
            onComplete={() => setIsArrowStopAnimationFinished(true)}
            loop={false}
          />
        )}
      </React.Suspense>
    </LazyErrorBoundary>
  )
}
